import { render, staticRenderFns } from "./layout-tools-agent.vue?vue&type=template&id=350bfe2c&scoped=true"
import script from "./layout-tools-agent.vue?vue&type=script&lang=js"
export * from "./layout-tools-agent.vue?vue&type=script&lang=js"
import style0 from "./layout-tools-agent.vue?vue&type=style&index=0&id=350bfe2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bfe2c",
  null
  
)

export default component.exports